module.exports = __webpack_public_path__ + "static/img/quality-control1.50f9620.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/quality-control1.jpg
// module id = 49ax
// module chunks = 0